function mergeStyleProps(...styles: (React.CSSProperties | null | undefined)[]) {
  return Object.assign({}, ...styles);
}

export default mergeStyleProps;
